import {lazy} from 'react';
import {Navigate, type RouteObject} from 'react-router-dom';

import AppInitializerGuard from '@/components/system/common/AppInitializerGuard';

const MapLayout = lazy(() => import('@/pages/map/pc/Map'));
const Search = lazy(() => import('@/pages/map/pc/Search'));
const LandInfo = lazy(() => import('@/pages/map/pc/LandInfo'));
const Life = lazy(() => import('@/pages/map/pc/Life'));
const Culture = lazy(() => import('@/pages/map/pc/Culture'));
const Safe = lazy(() => import('@/pages/map/pc/Safe'));
const Wanted = lazy(() => import('@/pages/map/pc/Wanted'));
const AirmapSlider = lazy(() => import('@/pages/map/pc/AirmapSlider'));
const CampaignMap = lazy(() => import('@/pages/map/pc/CampaignMap'));
const ConstructionNotification = lazy(() => import('@/pages/map/pc/ConstructionNotification'));
const StatisticMap = lazy(() => import('@/pages/map/pc/StatisticMap'));
const MapDownload = lazy(() => import('@/pages/map/pc/MapDownload'));
const VrVideo = lazy(() => import('@/pages/map/pc/VrVideo'));
const Banner = lazy(() => import('@/pages/map/pc/Banner'));

const pcMapRoutes: RouteObject[] = [
  {
    path: '/map',
    element: (
      <AppInitializerGuard>
        <MapLayout />
      </AppInitializerGuard>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="search" replace />
      },
      {
        path: 'search',
        element: <Search />
      },
      // {
      //   path: 'land-info',
      //   element: <LandInfo />
      // },
      {
        path: 'life',
        element: <Life />
      },
      {
        path: 'culture',
        element: <Culture />
      },
      {
        path: 'safe',
        element: <Safe />
      },
      {
        path: 'wanted',
        element: <Wanted />
      },
      {
        path: 'vr',
        element: <VrVideo />
      },
      {
        path: 'campaign',
        element: <CampaignMap />
      },
      {
        path: 'construct',
        element: <ConstructionNotification />
      },
      {
        path: 'slider',
        element: <AirmapSlider />
      },
      {
        path: 'statistic',
        element: <StatisticMap />
      },
      {
        path: 'download',
        element: <MapDownload />
      },
      {
        path: 'banner',
        element: <Banner />
      }
    ]
  }
];

export default pcMapRoutes;
